export default __webpack_public_path__ + "static/media/GsT.472b86f7.png";